import {
  ChangeDetectionStrategy,
  Component,
  inject,
  signal,
} from '@angular/core';
import { DialogRef } from '@angular/cdk/dialog';
import {
  SignalButton,
  SignalTextField,
  State,
} from '@vallift/ngl';
import { BaseComponent } from '@core/base/base-component';
import { WorkspaceAPIService } from '@core/api/workspace/services/workspace-api/workspaceAPI.service';
import type { ContactResponse } from '@core/api/workspace/models/contactResponse';
import type { CreateContactApiResponse } from '@core/api/workspace/models/createContactApiResponse';

export type CreateContactOverlayResult = ContactResponse;

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

@Component({
  selector: 'app-create-contact-overlay',
  standalone: true,
  imports: [SignalButton, SignalTextField],
  templateUrl: './create-contact-overlay.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CreateContactOverlayComponent extends BaseComponent {
  private readonly userAPIService = inject(WorkspaceAPIService);
  private readonly dialogRef = inject(
    DialogRef<CreateContactOverlayResult | null>,
  );

  readonly createState = new State<CreateContactApiResponse>();
  readonly firstName = signal('');
  readonly lastName = signal('');
  readonly email = signal('');

  close(): void {
    this.dialogRef.close(null);
  }

  onSave(): void {
    const firstName = this.firstName().trim();
    const lastName = this.lastName().trim();
    const email = this.email().trim().toLowerCase();

    if (!firstName) {
      this.toasterService.error('Enter a first name.');
      return;
    }
    if (!email || !EMAIL_PATTERN.test(email)) {
      this.toasterService.error('Enter a valid email address.');
      return;
    }

    this.executeRequest({
      state: this.createState,
      request: this.userAPIService.createContact({
        firstName,
        ...(lastName ? { lastName } : {}),
        email,
      }),
      showLoader: true,
      handleError: true,
      onSuccess: (response) => {
        this.toasterService.success('Contact created.');
        this.dialogRef.close(response.data);
      },
    });
  }
}
